<template>
	<div class="container">
		<div class="container-tit en">DONG GWANG BUILDING</div>
		<div class="pc-detail--image">
			<img src="../../assets/images/pc/detail/2_1.jpg" alt="" />
			<img src="../../assets/images/pc/detail/2_2.jpg" alt="" />
			<img src="../../assets/images/pc/detail/2_3.jpg" alt="" />
			<img src="../../assets/images/pc/detail/2_4.jpg" alt="" />
		</div>
		<div class="pc-detail--text">
			<ul class="left">
				<li class="item">
					<label class="label">LAND SPACE</label>
					1680PY (5553sqm)
				</li>
				<li class="item">
					<label class="label">TOTAL</label>
					1680PY (5553sqm)
				</li>
				<li class="item">
					<label class="label">FLOOR</label>
					B1 – 5F
				</li>
				<li class="item">
					<label class="label">PURPOSE</label>
					Company building
				</li>
				<li class="item">
					<label class="label">PURCHASE DATE</label>
					Dec 2019
				</li>
			</ul>
			<div class="right"></div>
		</div>
	</div>
	<div class="footer">
		<div class="footer-wrap">
			<div class="footer-logo"></div>
			<div class="footer-info">
				<div class="line">
					<span>대표 : 서치원</span>
					<span>사업자 등록번호 : 395-87-02794</span>
					<span>주소 : 서울특별시 강남구 도산대로26길 20, 1층(논현동, NEWTURN빌딩)</span>
				</div>
				<div class="line">
					<span>대표번호 : 02-6956-2791</span>
					<span>팩스 : 070-4693-5728</span>
				</div>
			</div>
			<div class="footer-copy">
				개인정보처리방침<br />
				Copyrightⓒ2023 WEONUS All rights reserved.
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'PC_Main',
	components: {},
	computed: {},
	data() {
		return {};
	},
	created() {},
	methods: {},
};
</script>
